export const invoices_sorting = [
  { label: "Payment date", value: "created_at:asc" },
  { label: "Payment date", value: "created_at:desc" },
  { label: "Website", value: "website:asc" },
  { label: "Website", value: "website:desc" },
  { label: "Subscription plan", value: "price_id:asc" },
  { label: "Subscription plan", value: "price_id:desc" },
  { label: "Amount", value: "amount:asc" },
  { label: "Amount", value: "amount:desc" },
];